// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Supplier Groups list */
.customer-group-list-card .MuiDataGrid-root {
  border: none;
}

.customer-group-list-card .MuiDataGrid-cell {
  border-bottom: 1px solid #e9ecef;
}

.customer-group-list-card .MuiDataGrid-columnHeaders {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.customer-group-list-card .MuiDataGrid-columnHeaderTitle {
  font-weight: 600;
  color: #495057;
}

.customer-group-list-card.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.customer-group-list-card .card-header {
  background-color: #f8f9fa;
}

.customer-group-list-card .breadcrumb {
  background-color: transparent;
  margin-bottom: 0.5rem;
}

.customer-group-list-card .breadcrumb-item {
  font-size: 0.95rem;
}

/* Form styles — aligned with Pricing Foundation */
.create-customer-group-card .form-label.required::after {
  content: " *";
  color: #dc3545;
}

.create-customer-group-card .form-label {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.5rem;
}

.create-customer-group-card .form-control,
.create-customer-group-card .form-select {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.625rem 0.75rem;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.create-customer-group-card .form-control:focus,
.create-customer-group-card .form-select:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  outline: none;
}

.create-customer-group-card .form-control.is-invalid,
.create-customer-group-card .form-select.is-invalid {
  border-color: #dc3545;
}

.create-customer-group-card .form-control.is-invalid:focus,
.create-customer-group-card .form-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.create-customer-group-card .invalid-feedback {
  display: block;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.create-customer-group-card .form-group {
  margin-bottom: 1.5rem;
}

.create-customer-group-card .btn-primary {
  background-color: #0d6efd;
  border-color: #0d6efd;
  font-weight: 500;
  padding: 0.625rem 1.5rem;
}

.create-customer-group-card .btn-primary:hover {
  background-color: #0b5ed7;
  border-color: #0a58ca;
}

.create-customer-group-card .btn-primary:disabled {
  background-color: #0d6efd;
  border-color: #0d6efd;
  opacity: 0.65;
  cursor: not-allowed;
}

.create-customer-group-card .btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
  font-weight: 500;
  padding: 0.625rem 1.5rem;
}

.create-customer-group-card .btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.create-customer-group-card .btn-outline-secondary:disabled {
  color: #6c757d;
  opacity: 0.65;
  cursor: not-allowed;
}

.create-customer-group-card.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid #dee2e6;
}

@media (max-width: 576px) {
  .create-customer-group-card .g-3 > * {
    --bs-gutter-x: 0.5rem;
    --bs-gutter-y: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/sku-management/customer-group/customerGroup.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,iDAAiD;EACjD,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;AACF","sourcesContent":["/* Supplier Groups list */\n.customer-group-list-card .MuiDataGrid-root {\n  border: none;\n}\n\n.customer-group-list-card .MuiDataGrid-cell {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.customer-group-list-card .MuiDataGrid-columnHeaders {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.customer-group-list-card .MuiDataGrid-columnHeaderTitle {\n  font-weight: 600;\n  color: #495057;\n}\n\n.customer-group-list-card.card {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.customer-group-list-card .card-header {\n  background-color: #f8f9fa;\n}\n\n.customer-group-list-card .breadcrumb {\n  background-color: transparent;\n  margin-bottom: 0.5rem;\n}\n\n.customer-group-list-card .breadcrumb-item {\n  font-size: 0.95rem;\n}\n\n/* Form styles — aligned with Pricing Foundation */\n.create-customer-group-card .form-label.required::after {\n  content: \" *\";\n  color: #dc3545;\n}\n\n.create-customer-group-card .form-label {\n  font-weight: 500;\n  color: #212529;\n  margin-bottom: 0.5rem;\n}\n\n.create-customer-group-card .form-control,\n.create-customer-group-card .form-select {\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n  padding: 0.625rem 0.75rem;\n  font-size: 0.95rem;\n  transition: all 0.2s ease;\n}\n\n.create-customer-group-card .form-control:focus,\n.create-customer-group-card .form-select:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n  outline: none;\n}\n\n.create-customer-group-card .form-control.is-invalid,\n.create-customer-group-card .form-select.is-invalid {\n  border-color: #dc3545;\n}\n\n.create-customer-group-card .form-control.is-invalid:focus,\n.create-customer-group-card .form-select.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.create-customer-group-card .invalid-feedback {\n  display: block;\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n}\n\n.create-customer-group-card .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.create-customer-group-card .btn-primary {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  font-weight: 500;\n  padding: 0.625rem 1.5rem;\n}\n\n.create-customer-group-card .btn-primary:hover {\n  background-color: #0b5ed7;\n  border-color: #0a58ca;\n}\n\n.create-customer-group-card .btn-primary:disabled {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.create-customer-group-card .btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n  font-weight: 500;\n  padding: 0.625rem 1.5rem;\n}\n\n.create-customer-group-card .btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.create-customer-group-card .btn-outline-secondary:disabled {\n  color: #6c757d;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.create-customer-group-card.card {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  border: 1px solid #dee2e6;\n}\n\n@media (max-width: 576px) {\n  .create-customer-group-card .g-3 > * {\n    --bs-gutter-x: 0.5rem;\n    --bs-gutter-y: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
